/**
 * customGesture.ts
 * 自作ジェスチャーカードの定義
 * 「ジェスチャー作成」で作ったモーションを選んでロボットに送るノード
 */
import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { CustomGestureNodeView } from '../views/CustomGestureNode';
import { CustomGestureSettings } from '../settings/CustomGestureSettings';
import { customMotionToTimeline, getCustomMotion, getCustomMotionLabel } from '../../config/customMotions';
import { runMotionCard } from './motionCardRun';

const VIRTUAL_MOTION_TIMEOUT_MS = 30000;

export const customGestureDefinition: NodeDefinition<'customGesture'> = {
  label: 'Create',
  showInPalette: true,
  paletteColor: 'bg-blue-100 border-blue-500 text-blue-700',
  miniMapColor: '#0075ff',
  defaultData: { label: 'Create', motionId: '' },
  view: CustomGestureNodeView,
  settings: CustomGestureSettings,
  run: (node, ctx, log) => {
    const motion = getCustomMotion(node.data.motionId);
    return runMotionCard(
      {
        logTag: 'CustomGesture',
        nodeKind: 'customGesture',
        nodeId: node.id,
        motionId: node.data.motionId,
        motionLabel: getCustomMotionLabel(node.data.motionId) ?? '（未設定）',
        virtualTimeoutMs: VIRTUAL_MOTION_TIMEOUT_MS,
        timeline: motion ? customMotionToTimeline(motion) : undefined,
        physicsEnabled: true,
        skipRobotMotion: !!motion,
        customGesture: motion,
      },
      ctx,
      log,
    );
  },
  help: {
    title: [t('Custom Gesture（'), r('自作', 'じさく'), t('のうごき）')],
    description: [
      r('自分', 'じぶん'),
      t('でつくった'),
      r('動', 'うご'),
      t('きを、ロボットが'),
      t('します。'),
      r('動', 'うご'),
      t('きが'),
      r('終', 'お'),
      t('わってから、つぎのカードへ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
